import styled from 'styled-components';

export const CompanyHomeContainer = styled.main`
  animation: fadeIn 0.7s;
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  /* border: 3px solid rebeccapurple; */
  height: 100vh;
  width: 80%;
  overflow-y: auto;
  padding: ${({ theme }) => theme.spacing.s};
  margin: 0 auto;
  header {
    text-align: center;
  }
  h3 {
    font-size: ${({ theme }) => theme.spacing.xl};
    margin-bottom: ${({ theme }) => theme.spacing.s};
  }
  .company-logo {
    /* border: 5px solid red; */
    height: 100px;
    width: 200px;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const CompanyNav = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.m};
  margin-bottom: ${({ theme }) => theme.spacing.l};
  .nav-link {
    background: ${({ theme }) => theme.colors.yellow1};
    color: ${({ theme }) => theme.colors.grey7};
    border-radius: 999px;
    padding: 0.7rem 2rem;
    font-weight: bold;
    box-shadow: 0 1px 6px #0001;
    transition:
      background 0.2s,
      color 0.2s,
      transform 0.2s;
    border: none;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    &:hover {
      background: ${({ theme }) => theme.colors.orange2};
      color: ${({ theme }) => theme.colors.white};
      transform: translateY(-2px) scale(1.04);
    }
  }
`;

export const CompanyDataDiv = styled.div`
  /* background: ${({ theme }) => theme.colors.offWhite}; */
  /* border-radius: ${({ theme }) => theme.borderRadius}; */
  margin-bottom: ${({ theme }) => theme.spacing.s};
  /* padding: 2rem; */
  /* border: 2px solid red; */
  p {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey1};
    padding: 0.3rem 0;
    color: ${({ theme }) => theme.colors.grey5};
    font-size: 0.9rem;
    /* font-size: 1.1rem; */
    /* border: 1px solid pink; */
    &:last-child {
      /* border-bottom: none; */
    }
  }

  h4,
  h5 {
    margin-top: ${({ theme }) => theme.spacing.s};
    color: ${({ theme }) => theme.colors.orange5};
  }
`;

// CompanyHome.styles.jsx
export const SectionBox1 = styled.section`
  background: ${({ theme }) => theme.colors.offWhite};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.shadows.shadow2};
  padding: 2.5rem 2rem;
  margin-bottom: ${({ theme }) => theme.spacing.l};
  position: relative;
  overflow: hidden;
  border: 2px solid ${({ theme }) => theme.colors.yellow3};
  display: flex;
  flex-direction: column;
  gap: 1rem;
  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 200px;
    height: 200px;
    background: linear-gradient(
      135deg,
      ${({ theme }) => theme.colors.yellow1} 60%,
      ${({ theme }) => theme.colors.orange2} 100%
    );
    opacity: 0.13;
    border-radius: 40px;
    z-index: 0;
  }
  &::before {
    top: -40px;
    left: -60px;
    transform: rotate(-15deg);
  }
  &::after {
    bottom: -40px;
    right: -60px;
    transform: rotate(15deg);
  }
  > * {
    position: relative;
    z-index: 1;
  }
  h3 {
    color: ${({ theme }) => theme.colors.orange2};
    /* margin-bottom: rem; */
  }
  p {
    color: ${({ theme }) => theme.colors.grey6};
    margin-bottom: 0.8rem;
  }
`;
export const SectionBox = styled.section`
  background: ${({ theme }) => theme.colors.offWhite};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.shadows.shadow2};
  padding: 2.5rem 2rem;
  margin-bottom: ${({ theme }) => theme.spacing.l};
  border: 1px solid ${({ theme }) => theme.colors.grey1};
  display: flex;
  flex-direction: column;
  gap: 1rem;
  h3,
  h4 {
    border-bottom: 3px solid ${({ theme }) => theme.colors.yellow3};
  }
  div {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  @media screen and (max-width: 768px) {
    padding: 1.5rem 1rem;
  }
`;
